<ng-container *transloco="let t">
  @if (loading()) {
    <app-loading></app-loading>
  } @else {
    <div class="container no-container-on-mobile mb-0 mt-3">
      <p-accordion ngSkipHydration [value]="['0']">
        @for (info of infos; track info) {
          <p-accordion-panel [value]="$index.toString()">
            <p-accordion-header>{{ info.title | translate }}</p-accordion-header>
            <p-accordion-content>
              @if (info.image) {
              <div class="flex text-center justify-content-center">
                <img width="300" [src]="info.image" alt="Cover image" draggable="false" class="img-fluid mb-3" />
              </div>
              }
              <div [innerHTML]="info.description | translate" class="mt-2"></div>

              @let filesForLang = info.attachments && info.attachments[currentLang] ? info.attachments[currentLang] : null;
              @if (filesForLang && filesForLang.length > 0) {
              <div class="mt-4">
                <h4 class="mb-2">{{ t('attachments') }}</h4>
                <ul class="list-none p-0">
                  @for (file of filesForLang; track file.path) {
                  <a [href]="file.path" target="_blank" class="no-underline text-900" [attr.aria-label]="'Scarica ' + file.nome">
                    <li class="mb-3 flex align-items-center border-1 border-gray-300 border-round p-2">
                      <img [src]="getFileImage(file.extension)" (error)="$event.target.src='/files/file.png'" alt="" class="mr-2" style="width: 32px; height: 32px;">
                      <span class="ml-2 flex-grow-1 font-semibold">{{ file.original_name }}</span>
                      <span class="material-icons text-green-600" aria-hidden="true">download</span>
                    </li>
                  </a>
                  }
                </ul>
              </div>
              }
            </p-accordion-content>
          </p-accordion-panel>
        }
      </p-accordion>
    </div>
  }
</ng-container>
